import axios, { AxiosResponse } from "axios";
import { useStore } from "../store/store";
import { CAS_LOGIN_URL } from "../utils/index";

// 创建axios实例
const service = axios.create({
  // baseURL: "http://10.168.1.224:16333/nkdmobile/",
 //baseURL: "http://10.168.1.192:8080/nkdmobile/", //
  baseURL: "https://sdsfpt.sustech.edu.cn/nkdmobile/", // 正式
  timeout: 5 * 60 * 1000,
});

/**
 * 获取本地保存的 XCX-Token
 * 1. 优先从 zustand store 读取（persist 已同步恢复自 localStorage 的 nkd-storage）
 * 2. 兜底从 localStorage 解析，兼容异常情况
 */
const getXcxToken = (): string => {
  const storeToken = useStore.getState().token;
  if (storeToken) return storeToken;
  try {
    const raw = window.localStorage.getItem("nkd-storage");
    if (raw) {
      const parsed = JSON.parse(raw);
      return parsed?.state?.token || "";
    }
  } catch (e) {
    // 解析失败忽略
  }
  return "";
};

// 401 处理防抖：并发请求同时 401 时只处理一次，避免重复跳转
let handling401 = false;
const handleUnauthorized = () => {
  if (handling401) return;
  handling401 = true;
  // 清除登录态与旧 ticket，重新走 CAS 换票（CAS 回调后 /login 会重新调 /app/xcx/nkd/login 获取新 token）
  useStore.getState().updateToken("");
  useStore.getState().updateTokenExpireAt(0);
  window.localStorage.removeItem("ticket");
  window.location.replace(CAS_LOGIN_URL);
};

service.interceptors.request.use(
  (config) => {
    // 所有经过 service 实例的请求统一携带 XCX-Token，后端 XcxAuthorizationInterceptor 从 header 读取
    const token = getXcxToken();
    if (token) {
      config.headers["XCX-Token"] = token;
    }
    return config;
  },
  (error) => {
    console.log("ca fafa", error); // for debug
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response: AxiosResponse) => {
    // 后端鉴权失败时 HTTP 状态为 401 且响应体 code 为 401
    if (response.data && response.data.code === 401) {
      handleUnauthorized();
    }
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    const code = error?.response?.data?.code;
    if (status === 401 || code === 401) {
      handleUnauthorized();
      // 归一化返回，页面按 res.data.code != 0 处理（提示语），随后页面跳转 CAS
      return Promise.resolve({
        data: {
          code: 401,
          msg: error?.response?.data?.msg || "登录已过期，请重新登录",
        },
      });
    }
    // 其他错误归一化返回，避免页面出现未捕获的 Promise 异常（各页面统一读 res.data.code）
    console.log("response error", error); // for debug
    return Promise.resolve({
      data: { code: status ?? -1, msg: error?.message || "网络异常" },
    });
  }
);

export const post = async (url: string, data?: Record<string, any>, ...arg: Record<string, any>[]) => {
  const result = await service.post(url, data, ...arg);
  return result;
};
export const get = async (url: string, data?: Record<string, any>, ...arg: Record<string, any>[]) => {
  const result = await service.get(url, {
    params: {
      ...data,
    },
    ...arg,
  });
  return result;
};
